import script from "./SkeletonGroupList.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonGroupList.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonGroupList.vue?vue&type=style&index=0&id=6664f37c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lms-v3-backend/lms-v3-backend/.vapor/build/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6664f37c"]])

export default __exports__